/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdQueryResponse,
  GetApiV1PersonIdPathParams,
  GetApiV1PersonId401,
  GetApiV1PersonId404,
  GetApiV1PersonId500,
} from "../../types/personRegisterController/GetApiV1PersonId.ts";

function getGetApiV1PersonIdUrl(id: GetApiV1PersonIdPathParams["id"]) {
  const res = { method: "GET", url: `/api/v1/person/${id}` as const };
  return res;
}

/**
 * @description Retorna os detalhes completos de uma pessoa pelo ID. **(Requer Authorization para autenticação)**
 * @summary Obter pessoa por ID (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id}
 */
export async function getApiV1PersonId(
  id: GetApiV1PersonIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1PersonId401 | GetApiV1PersonId404 | GetApiV1PersonId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
